import * as React from "react";
import { useNavigate } from "react-router-dom";
import { linksOf } from "../../services/cpln";
import { Command } from "../../schema/types/command";
import { BasePathContext } from "../../reactContexts/basePathContext";
import { ngParseLink } from "../../utils/linkParser/linkParser";
import { NGButton } from "../../newcomponents/button/Button";
import moment from "moment-timezone";
import { Timezone } from "../../mobxStores/userData/timezone";
import { observer } from "mobx-react-lite";

interface Props {
  command: Command;
  containerName?: string;
}
const CommandActionsRaw: React.FC<Props> = ({ command, containerName }) => {
  const navigate = useNavigate();
  const basePath = React.useContext(BasePathContext);

  if (command.type !== "runCronWorkload") {
    return null;
  }

  const info = React.useMemo(() => {
    const { name: workloadName, gvc: workloadGvc } = ngParseLink(linksOf(command).target!, { useInputCtx: true });
    return { workloadName, workloadGvc };
  }, [command]);
  const { workloadName, workloadGvc } = info;

  const created = React.useMemo(() => {
    const d = moment(command.created);
    d.subtract(1, "day");
    return d.toISOString();
  }, [command, Timezone.isLocal]);

  // Limit time to 7 days, also in job executions
  let processedCompletionDateString = "";
  const now = moment();
  if (now.diff(moment(created), "day") > 7) {
    const limitedCompletionDate = moment(created).add(1, "week");
    processedCompletionDateString = limitedCompletionDate.toISOString();
  }

  const logLink = `${basePath}/-logs?query=${encodeURIComponent(
    `{gvc="${workloadGvc}", location="${command.spec!.location}", workload="${workloadName}", replica="${
      command.status?.replica
    }"}`,
  )}&from=${moment(created).toISOString()}${
    processedCompletionDateString ? `&to=${processedCompletionDateString}` : ""
  }&execute=true&live=${!processedCompletionDateString && command.lifecycleStage === "running" ? "true" : "false"}`;

  let connectLink = "";
  if (containerName) {
    connectLink = `${basePath}/-connect?location=${command.spec!.location}&container=${containerName}&replica=${
      command.status?.replica
    }&autoConnect=true`;
  }

  return (
    <div className="flex items-center gap-2 mb-4">
      <NGButton variant="primary" onClick={() => navigate(logLink)} disabled={!command.status?.replica}>
        See Logs
      </NGButton>
      {connectLink ? (
        <NGButton
          variant="primary"
          onClick={() => navigate(connectLink)}
          disabled={command.lifecycleStage !== "running"}
        >
          Connect {command.lifecycleStage !== "running" ? `(Not Running)` : ""}
        </NGButton>
      ) : null}
    </div>
  );
};

export const CommandActions = observer(CommandActionsRaw);
